export default "__VITE_ASSET__DzwEX45a__ 720w";